import PropTypes from 'prop-types';
import { Fragment } from 'react';
import styled from 'styled-components';
import Link from 'next/link';

import { theme } from '_constants/theme';

const StyledContainer = styled.div`
  padding-top: ${theme.spaces.small2X}px;
  padding-bottom: ${theme.spaces.small2X}px;
  padding-left: ${theme.spaces.small}px;
  padding-right: ${theme.spaces.small}px;

  background: ${theme.colors.white};
  border-radius: 10px;

  a,
  span {
    font-family: 'Aeonik';
    font-size: ${theme.fontSizes.regular}px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    text-decoration: none;
    color: ${theme.colors.gray[800]};
  }

  a:hover {
    text-decoration: underline;
  }
`;

const Breadcrumbs = ({ items }) => {
  return (
    <StyledContainer>
      {items?.map(({ label, path }, idx, arr) => (
        <Fragment key={path}>
          <Link href={path}>{label}</Link>
          {idx < arr.length - 1 && <span>&nbsp;|&nbsp;</span>}
        </Fragment>
      ))}
    </StyledContainer>
  );
};

Breadcrumbs.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      path: PropTypes.string,
    })
  ),
};

export default Breadcrumbs;
